<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                  <label style="font-weight: bold; font-style: italic"
                    >Mã phiếu: {{ documentNoField.data.model }}</label
                  >
                  <br />
                  <label
                    style="
                      font-weight: bold;
                      font-style: italic;
                      padding-right: 1%;
                    "
                    ><span>Trạng thái: </span>
                    <span v-if="stateField.data.model == 'draft'">Nháp</span>
                    <!-- <span v-if="stateField.data.model == 'confirm'" style="color: #f9b115">Xác nhận</span> -->
                    <span v-if="isDone" style="color: #2eb85c">Hoàn thành</span>
                    <!-- <span v-if="stateField.data.model == 'cancel'" style="color: #e55353">Hủy bỏ</span> -->
                  </label>
                  <br />
                  <label
                    v-if="isDone"
                    style="font-weight: bold; font-style: italic"
                    >Ngày hoàn thành:
                    {{
                      $helper.formatDateDDMMYYYYHHMM(
                        accountingDateInput.data.model
                      )
                    }}</label
                  >
                </CCol>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                  <div style="float: right">
                    <CButton
                      color="secondary"
                      class="btn-action-primary mr-2"
                      @click="$router.push('/stock-management/list.html')"
                      ><i class="fa fa-reply"></i>
                      Quay lại
                    </CButton>
                    <CButton
                      color="primary"
                      v-if="!isDone"
                      class="btn-action-primary mr-2"
                      @click="submitData()"
                    >
                      <i class="fa fa-save"></i> Lưu lại
                    </CButton>
                    <CButton
                      color="primary"
                      v-if="isDone"
                      class="btn-action-primary mr-2"
                      @click="updateDescription()"
                    >
                      <i class="fa fa-save"></i> Cập nhật mô tả
                    </CButton>
                    <CButton
                      color="primary"
                      class="btn-action-primary mr-2"
                      @click="exportReport()"
                    >
                      <i class="fa fa-download"></i> Xuất báo cáo
                    </CButton>
                    <CButton
                      color="primary"
                      class="btn-action-primary mr-2"
                      @click="exportReportSerial()"
                    >
                      <i class="fa fa-download"></i> Xuất serial/mac
                    </CButton>
                    <!-- <CButton v-if="stateField.data.model == 'draft'" color="warning" class="btn-action-primary mr-2" @click="submitData()">
                                            <i class="fa fa-check"></i> Xác nhận
                                        </CButton>
                                        <CButton v-if="stateField.data.model == 'confirm' || stateField.data.model == 'done'" color="danger" class="btn-action-primary mr-2" @click="submitData()">
                                            <i class="fa fa-times"></i> Hủy phiếu
                                        </CButton> -->
                    <CButton
                      v-if="stateField.data.model == 'draft'"
                      color="success"
                      class="btn-action-primary"
                      @click="
                        setupSelectOneAction(
                          'action_done',
                          idField.data.model,
                          documentNoField.data.model
                        )
                      "
                    >
                      <i class="fa fa-check"></i> Hoàn thành
                    </CButton>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                  <CRow>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect
                        :options="inventoryTypeSelect.options"
                        :disabled="isDone"
                        :data="inventoryTypeSelect.data"
                        ref="inventoryTypeSelect"
                      ></BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect
                        :options="warehouseSelect.options"
                        :data="warehouseSelect.data"
                        :disabled="isDone"
                        ref="warehouseSelect"
                      ></BaseSelect>
                    </CCol>
                    <CCol
                      xs="12"
                      sm="12"
                      md="6"
                      lg="6"
                      xl="6"
                      v-show="inventoryTypeSelect.data.model == 'out'"
                    >
                      <BaseSelect
                        :options="customerSelect.options"
                        :data="customerSelect.data"
                        :disabled="isDone"
                        ref="customerSelect"
                      ></BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <div class="form-group" style="width: 100%">
                        <CRow>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <label for="datepicker"
                              >Ngày chứng từ
                              <span class="required">* </span>
                            </label>
                          </CCol>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <div>
                              <DatePicker
                                id="inventoryDate"
                                v-model="inventoryDateInput.data.model"
                                locale="vi"
                                :disabled="isDone"
                                class="datepicker"
                                :input-props="{ readonly: true }"
                                :masks="{
                                  input: 'DD/MM/YYYY',
                                  data: 'DD/MM/YYYY',
                                }"
                                :popover="{ visibility: 'click' }"
                              >
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    :disabled="isDone"
                                    class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                                    readonly
                                  />
                                </template>
                              </DatePicker>
                              <div
                                class="valid-error"
                                v-show="
                                  !(inventoryDateInput.data.validator
                                    ? inventoryDateInput.data.validator.isValid
                                    : true)
                                "
                              >
                                {{
                                  inventoryDateInput.data.validator
                                    ? inventoryDateInput.data.validator
                                        .errorMessage
                                    : ""
                                }}
                              </div>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <div class="form-group" style="width: 100%">
                        <CRow>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <label for="datepicker"
                              >Ngày tính bảo hành
                              <span class="required">* </span>
                            </label>
                          </CCol>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <div>
                              <DatePicker
                                id="inventoryDate"
                                v-model="warrantyDateInput.data.model"
                                locale="vi"
                                class="datepicker"
                                :disabled="isDone"
                                :input-props="{ readonly: true }"
                                :masks="{
                                  input: 'DD/MM/YYYY',
                                  data: 'DD/MM/YYYY',
                                }"
                                :popover="{ visibility: 'click' }"
                              >
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    :disabled="isDone"
                                    class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                                    readonly
                                  />
                                </template>
                              </DatePicker>
                              <div
                                class="valid-error"
                                v-show="
                                  !(warrantyDateInput.data.validator
                                    ? warrantyDateInput.data.validator.isValid
                                    : true)
                                "
                              >
                                {{
                                  warrantyDateInput.data.validator
                                    ? warrantyDateInput.data.validator
                                        .errorMessage
                                    : ""
                                }}
                              </div>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseInput
                        :options="quantityInput.options"
                        :data="quantityInput.data"
                        :disabled="isDone"
                      />
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <div class="form-group" style="width: 100%">
                        <CRow>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <label>{{ totalPriceInput.options.label }}</label>
                          </CCol>

                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <div>
                              <currency-input
                                :disabled="
                                  totalPriceInput.options.disabled || isDone
                                "
                                class="form-control"
                                v-model="totalPriceInput.data.model"
                                currency="VND"
                                locale="vi"
                              />
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                    </CCol>

                    <CCol
                      xs="12"
                      sm="12"
                      md="10"
                      lg="10"
                      xl="10"
                      v-if="inventoryTypeSelect.data.model == 'in'"
                    >
                      <div class="form-group">
                        <label class="form-label">Nhập mới</label>
                        <CInputCheckbox
                          custom
                          :checked="isNewCheckBox.data.model"
                          class="ml-2"
                          @update:checked="changeIsNew($event)"
                          addInputClasses="override-custom"
                        >
                        </CInputCheckbox>
                      </div>
                    </CCol>

                    <CCol sm="12" md="12" xl="12">
                      <BaseTextArea
                        :options="descriptionInput.options"
                        :data="descriptionInput.data"
                        v-model="descriptionInput.data.model"
                      />
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <StockInventoryLines
      :products="stockLineSelect.data.model"
      :removeListLine="lstIdRemoveStockLines.data.model"
      :isDone="isDone"
      @sum-total="sumTotal($event)"
    />

    <BaseExportModal
      v-if="isShowExportReport"
      :id="idField.data.model"
      :uri="uriExport"
      @close-modal="closeExportReport($event)"
    ></BaseExportModal>

    <BaseLoading :loading="loading.value"></BaseLoading>

    <ModalConfirm2
      :actionTypeMapping="actionData.actionTypeMapping"
      ref="actionModal"
    ></ModalConfirm2>
  </div>
</template>
  
<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea";
import { DatePicker } from "v-calendar";
import StockInventoryLines from "../stock/StockInventoryLines";
import BaseExportModal from "../base/BaseExportModal";
import ModalConfirm2 from "../base/BaseModalConfirm2.vue";

export default {
  name: "StockUpdate",
  components: {
    BaseSelect,
    BaseInput,
    BaseLoading,
    BaseTextArea,
    DatePicker,
    StockInventoryLines,
    BaseExportModal,
    ModalConfirm2,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("action_done", {
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "hoàn thành phiếu",
          that.actionData.model.selectedName
        );
      },
      submitAction: function () {
        that.actionDone();
      },
    });

    return {
      loading: { value: false },
      isDone: false,
      isActionDone: false,
      isShowExportReport: false,
      uriExport: "",
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          selectedId: null,
          selectedName: null,
          listSelectedId: [],
        },
      },
      stateField: {
        data: {
          model: "",
          name: "state",
        },
      },
      documentNoField: {
        data: {
          model: "",
          name: "documentNo",
        },
      },
      lstIdRemoveStockLines: {
        options: {
          label: "Chi tiết xóa",
        },
        data: {
          name: "lstIdRemoveStockLines",

          model: [],
        },
      },
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id",
        },
      },
      customerId: "",
      warehouseId: "",
      isNewCheckBox: {
        options: {
          label: "Nhập mới",
        },
        data: {
          name: "isNew",
          model: false,
          updateCallback: function () {
            that.submitData();
          },
        },
      },
      quantityInput: {
        options: {
          label: "Tổng số lượng",
          placeholder: "Tổng số lượng",
          maxlength: 64,
          disabled: true,
        },
        data: {
          name: "quantity",
          model: 0,
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              return this.isValid;
            },
          },
        },
      },
      totalPriceInput: {
        options: {
          label: "Tổng tiền",
          placehder: "Tổng tiền",
          type: "text",
          disabled: true,
        },
        data: {
          name: "totalPrice",
          model: 0,
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              return this.isValid;
            },
          },
        },
      },
      descriptionInput: {
        options: {
          label: "Ghi chú",
          placeholder: "Ghi chú",
          maxlength: 512,
          rows: 5,
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            if (!that.isDone) {
              that.submitData();
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              // let value = that.descriptionInput.data.model;
              // if (value === "" || value.trim() === "") {
              //     this.isValid = false;
              //     this.errorMessage = "Ghi chú bản tin không được để trống";
              // } else {
              //     this.isValid = true;
              // }
              return this.isValid;
            },
          },
        },
      },
      warehouseSelect: {
        options: {
          filter: true,
          label: "Kho <span class='required'>*</span>",
          selectAllText: "Chọn kho",
          keyField: "value",
          valueField: "text",
        },
        data: {
          name: "warehouseId",
          items: [],
          model: null,
          source: {
            url: "/warehouse/list-warehouse",
            dataSubmit: function () {
              return {};
            },
            response: function (dataResponse) {
              that.warehouseSelect.data.items = dataResponse.data;
              setTimeout(() => {
                that.warehouseSelect.data.model = that.warehouseId;
              }, 1000);
            },
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.warehouseSelect.data.model;
              if (!value || value === "") {
                this.isValid = false;
                this.errorMessage = "Kho không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      customerSelect: {
        options: {
          filter: true,
          label: "Khách hàng <span class='required'>*</span>",
          selectAllText: "Chọn khách hàng",
          keyField: "value",
          valueField: "text",
        },
        data: {
          name: "customerId",
          items: [],
          model: null,
          source: {
            url: "/customer/list-customer",
            dataSubmit: function () {
              return {};
            },
            response: function (dataResponse) {
              that.customerSelect.data.items = dataResponse.data;
              if (that.customerId) {
                setTimeout(() => {
                  that.customerSelect.data.model = that.customerId;
                }, 1000);
              }
            },
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              if ("out" == that.inventoryTypeSelect.data.model) {
                let value = that.customerSelect.data.model;
                if (!value || value === "") {
                  this.isValid = false;
                  this.errorMessage = "Khách hàng không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
              }

              return this.isValid;
            },
          },
        },
      },
      inventoryTypeSelect: {
        options: {
          filter: false,
          label: "Loại phiếu <span class='required'>*</span>",
        },
        data: {
          name: "inventoryType",
          items: [
            { key: "in", value: "Nhập kho" },
            { key: "out", value: "Xuất kho" },
          ],
          model: "in",
          updateCallback: function () {
            that.submitData();
          },
        },
      },
      inventoryDateInput: {
        options: {
          label: "Ngày chứng từ <span class='required'>*</span>",
        },
        data: {
          name: "inventoryDate",
          model: new Date(),
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.inventoryDateInput.data.model;
              if (!value || value === "") {
                this.isValid = false;
                this.errorMessage = "Ngày chứng từ không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      warrantyDateInput: {
        options: {
          label: "Ngày tính bảo hành <span class='required'>*</span>",
        },
        data: {
          name: "warrantyDate",
          model: new Date(),
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.warrantyDateInput.data.model;
              if (!value || value === "") {
                this.isValid = false;
                this.errorMessage = "Ngày chứng từ không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      accountingDateInput: {
        options: {
          label: "Ngày hoàn thành",
        },
        data: {
          name: "accountingDate",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              return this.isValid;
            },
          },
        },
      },
      stockLineSelect: {
        options: {
          label: "Dòng chi tiết",
        },
        data: {
          name: "stockLines",
          model: [],
        },
      },
    };
  },
  methods: {
    changeIsNew(event) {
        this.isNewCheckBox.data.model = event;
    },
    actionDone() {
      this.isActionDone = true;
      this.submitData();
    },
    submitDone: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/stock/done",
        isJsonContentType: false,
        dataSubmit: function () {
          return { id: that.idField.data.model };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Hoàn thành phiếu thành công",
            });
            // that.$router.go(-1);
            window.location.reload();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        },
      });
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.warehouseSelect.data.validator.valid();
      isValid &= this.customerSelect.data.validator.valid();
      isValid &= this.inventoryDateInput.data.validator.valid();
      isValid &= this.warrantyDateInput.data.validator.valid();

      let errorMessage = "";
      for (var i = 0; i < that.stockLineSelect.data.model.length; i++) {
        if (!that.stockLineSelect.data.model[i].productId) {
          errorMessage += "Dòng " + (i + 1) + " sản phẩm bắt buộc nhập \n";
          isValid = false;
        }
        if (that.stockLineSelect.data.model[i].quantity <= 0) {
          errorMessage += "Dòng " + (i + 1) + " số lượng phải lớn hơn 0 \n";
          isValid = false;
        }
      }

      if (errorMessage.length > 0) {
        that.showErrorMsg({ message: errorMessage });
      }

      if (!isValid) {
        that.isActionDone = false;
        return;
      }

      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/stock/update",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            if (that.isActionDone) {
              that.submitDone();
            } else {
              that.showSuccessMsg({
                message: "Cập nhật phiếu thành công",
              });
              // that.$router.go(-1);
              window.location.reload();
            }
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    sumTotal() {
      let totalPrice = 0;
      let totalQuantity = 0;
      for (let i = 0; i < this.stockLineSelect.data.model.length; i++) {
        totalQuantity += this.stockLineSelect.data.model[i].quantity * 1;
        totalPrice +=
          this.stockLineSelect.data.model[i].unitPrice *
          this.stockLineSelect.data.model[i].quantity;
      }
      this.totalPriceInput.data.model = totalPrice;
      this.quantityInput.data.model = totalQuantity;
    },
    loadData() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/stock/findById",
        isJsonContentType: false,
        dataSubmit: function () {
          return { id: that.idField.data.model };
        },
        successCallback: function (response) {
          that.$helper.setupDataResponse(that.$data, response.data.data);
          that.isDone = "done" == response.data.data.state;
          that.warehouseId = response.data.data.warehouseId;
          if (response.data.data.customerId) {
            that.customerId = response.data.data.customerId;
          }

          that.lstIdRemoveStockLines.data.model = [];

          // that.customerSelect.data.model = response.data.data.customerId;
          // that.warehouseSelect.data.model = response.data.data.warehouseId;
          that.loading.value = false;
          that.loadDataDetail();
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        },
      });
    },
    loadDataDetail() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/stock-line/findByStockId",
        isJsonContentType: false,
        dataSubmit: function () {
          return { stockId: that.idField.data.model };
        },
        successCallback: function (response) {
          that.stockLineSelect.data.model = response.data.data;
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        },
      });
    },
    exportReport() {
      this.uriExport = "/stock/export";
      this.isShowExportReport = true;
    },
    closeExportReport(event) {
      this.uriExport = "";
      this.isShowExportReport = false;
    },
    exportReportSerial() {
      this.uriExport = "/stock/export-serial";
      this.isShowExportReport = true;
    },
    setupSelectOneAction: function (actionTypeKey, selectedId, selectedName) {
      let actionData = this.actionData.model;
      actionData.selectedId = selectedId || null;
      actionData.selectedName = selectedName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    updateDescription: function () {
      let that = this;
      
      // Validate description if needed
      if (!that.descriptionInput.data.validator.valid()) {
        return;
      }

      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/stock/update",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật mô tả thành công",
            });
            // Reload to refresh data
            window.location.reload();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
  },
  computed: {},
  created() {},
  mounted() {
    this.loadData();
  },
  watch: {},
};
</script>

<style scoped>
.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
  color: rgb(255, 255, 255);
  font-size: 10px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: #4bb543;
}

.stepper-item.cancel .step-counter {
  background-color: #f80202;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #4bb543;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}
</style>